import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppRoutes } from '@helpers/app-routes';
import { TerminalService } from '@services/terminal.service';

export const hasInstanceGuard: CanActivateFn = () => {
  const terminalService = inject(TerminalService);
  const router = inject(Router);

  return terminalService.hasSelectedInstance() ? true : router.createUrlTree([AppRoutes.chooseInstance]);
};
